import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const HistoryIcon = ({ size = 24, ...props }: IconProps) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 19 22" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path 
      d="M17.2831 9.32933V18.6923C17.2831 19.3043 17.0399 19.8913 16.6071 20.3241C16.1744 20.7569 15.5874 21 14.9754 21H4.20613C3.59409 21 3.00712 20.7569 2.57435 20.3241C2.14157 19.8913 1.89844 19.3043 1.89844 18.6923V3.30769C1.89844 2.69565 2.14157 2.10868 2.57435 1.67591C3.00712 1.24313 3.59409 1 4.20613 1H8.95373C9.36161 1.00006 9.75278 1.1621 10.0412 1.45048L16.8326 8.24183C17.121 8.53028 17.283 8.92144 17.2831 9.32933Z" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinejoin="round"
    />
    <path 
      d="M9.59127 1.38281V7.15204C9.59127 7.56007 9.75336 7.95138 10.0419 8.2399C10.3304 8.52842 10.7217 8.6905 11.1297 8.6905H16.899M5.74512 12.5367H13.4374M5.74512 16.3828H13.4374" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default HistoryIcon;
